import { Column, ColumnConfig, IColumn } from "../base-column/column.model";
import { ColumnTypeEnum } from "../base-column/column-type-enum";
import { Currencies } from "./currencies-enum";
import { CurrencyPosition } from "./currency-position-enum";
import { initFromConfig, initFromProps } from "../common-models/init-functions";

// Πρέπει να δημιουργηθεί Component το οποία θα επεκτείνει την Abstract BaseColumn και θα περιέχει τουλάχιστον τα παρακάτω.
export class CurrencyColumn<T> extends Column<T> implements IColumn<T>{

  CurrencySymbol: Currencies = Currencies.Euro;
  CurrencyPosition: CurrencyPosition = CurrencyPosition.After;
  DecimalSeperator : string  = ',';
  ThousandsSeperator : string = '.';

  constructor(config: ColumnConfig<T>);
  constructor(
    name?: string,
    propertyName?: string,
    sort?: boolean,
    tooltip?: string | ((item?: any) => string),
    action?: (item?: T, event? : any) => any,
    currencySymbol?: Currencies,
    currencyPosition?:CurrencyPosition,
    decimalSeperator?: string,
    thousandsSeperator? : string
  );
  constructor(
    configOrName?: ColumnConfig<T> | string,
    propertyName?: string,
    sort?: boolean,
    tooltip?: string | ((item?: any) => string),
    action?: (item?: T, event? : any) => any,
    currencySymbol?: Currencies,
    currencyPosition?:CurrencyPosition,
    decimalSeperator?: string,
    thousandsSeperator? : string
  ) {
    super();
    if (typeof configOrName === 'object') {
      const config = configOrName as ColumnConfig<T>;
      initFromConfig(this, config);
    } else {
      initFromProps(this, configOrName, propertyName, sort, tooltip, action);
      this.CurrencySymbol = currencySymbol ?? Currencies.Euro;
      this.CurrencyPosition = currencyPosition ?? CurrencyPosition.After;
      this.DecimalSeperator = decimalSeperator ?? ',';
      this.ThousandsSeperator = thousandsSeperator ?? '.';
    }
  }

  GetAction(row: T, event? : any) {
    if (this.Action) {
      if(event){
        return this.Action(row, event);
      }
      return this.Action(row);
    } else {
      throw new Error('Action is not defined in currency column.');
    }
  }

  GetTooltip(): string | ((item?: any) => string) {
    return this.Tooltip ?? null;
  }

  GetSort(): boolean {
    return this.Sort ?? false;
  }
  GetPropertyName(): string{
    return this.PropertyName ?? null;
  }
  GetName(): string {
    return this.Name ?? '';
  }
  //Θα επιστρέφει το αντίστοιχο entry από το Enum για DateColumn
  GetColumnType(): string {
    return ColumnTypeEnum.CurrencyColumn;
  }

  //Θα πρέπει να επιστρέφει το value που θα εμφανιστεί στο grid βασισμένο στο Propertyname μετά από τους μετασχηματισμούς.
  //Για την υποστήριξη των nested object θα πρέπει να υπάρχει split και recursive αναζήτηση των properties.
  GetValue(): string | ((item?: any) => string){
    return this.Action ?? this.CurrencyFormat.bind(this) ?? '';
  }

  CurrencyFormat(obj: string): string{
    const value = parseFloat(obj);

    if(isNaN(value)){
      return 'NaN'
    }

    const formattedValue = value.toLocaleString('de-DE', {
      style: 'currency',
      currency: this.CurrencySymbol,
      minimumFractionDigits: 2
    });

    if (this.CurrencyPosition === CurrencyPosition.After) {
      return formattedValue;
    } else {
      const currency = formattedValue.charAt(formattedValue.length - 1);
      const parts = formattedValue.split(currency);
      if (parts.length === 2) {
        return `${currency} ${parts[0].trim()}`;
      } else {
        return formattedValue;
      }
    }
  }
}
